import React, { useEffect, useMemo, useState } from "react";
import API from "../../api";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "./rekapsanksi.css";

import "./rekap-sanksi-match-training-v1.css";
import "./hrd-table-header-center-crisp-v3.css";
import SearchableSelect from "./SearchableSelect";
const BASE = "/rekap-sanksi";
const EMPTY = {
  jobprofil_id: "",
  nomor_surat: "",
  level_sanksi: "SP1",
  tanggal_kesalahan: "",
  kesalahan: "",
  masa_aktif_awal: "",
  masa_aktif_akhir: "",
  status_manual: "",
  status_sumber: "",
  keterangan: "",
};

const fmtDate = (v) => {
  if (!v) return "-";
  const s = String(v).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : s;
};

const stamp = () => {
  const d = new Date();
  return `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,"0")}${String(d.getDate()).padStart(2,"0")}`;
};

const errMsg = (e, fb) => e?.response?.data?.message || fb;

export default function RekapSanksi() {
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({ employees: [], departments: [], levels: [], statuses: [] });
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);

  const [q, setQ] = useState("");
  const [dept, setDept] = useState("");
  const [jobprofilId, setJobprofilId] = useState("");
  const [level, setLevel] = useState("");
  const [status, setStatus] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({ page:1, limit:10, total:0, totalPages:1 });

  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const filterParams = (custom={}) => ({
    q: Object.prototype.hasOwnProperty.call(custom,"q") ? custom.q : q,
    dept: Object.prototype.hasOwnProperty.call(custom,"dept") ? custom.dept : dept,
    jobprofil_id: Object.prototype.hasOwnProperty.call(custom,"jobprofil_id") ? custom.jobprofil_id : jobprofilId,
    level: Object.prototype.hasOwnProperty.call(custom,"level") ? custom.level : level,
    status: Object.prototype.hasOwnProperty.call(custom,"status") ? custom.status : status,
    from: Object.prototype.hasOwnProperty.call(custom,"from") ? custom.from : from,
    to: Object.prototype.hasOwnProperty.call(custom,"to") ? custom.to : to,
  });

  const loadMeta = async () => {
    const r = await API.get(`${BASE}/meta`);
    setMeta(r.data || {});
  };

  const loadRows = async (custom={}) => {
    try {
      setLoading(true);
      const reqPage = Object.prototype.hasOwnProperty.call(custom,"page") ? custom.page : page;
      const reqLimit = Object.prototype.hasOwnProperty.call(custom,"limit") ? custom.limit : limit;
      const r = await API.get(BASE, { params: { ...filterParams(custom), page:reqPage, limit:reqLimit }});
      setRows(Array.isArray(r.data?.rows) ? r.data.rows : []);
      setPagination(r.data?.pagination || {page:reqPage,limit:reqLimit,total:0,totalPages:1});
    } catch(e) {
      alert(errMsg(e, "Gagal mengambil Rekap Sanksi."));
    } finally {
      setLoading(false);
    }
  };

  const loadSummary = async (custom={}) => {
    try {
      const r = await API.get(`${BASE}/summary`, { params: filterParams(custom) });
      setSummary(r.data || {});
    } catch(e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadMeta().catch(e => alert(errMsg(e,"Gagal mengambil master karyawan.")));
    loadRows();
    loadSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  const applyFilter = async (e) => {
    e?.preventDefault();
    setPage(1);
    await Promise.all([loadRows({page:1}), loadSummary()]);
  };

  const resetFilter = async () => {
    setQ(""); setDept(""); setJobprofilId(""); setLevel(""); setStatus(""); setFrom(""); setTo("");
    setPage(1); setLimit(10);
    const clean = {q:"",dept:"",jobprofil_id:"",level:"",status:"",from:"",to:"",page:1,limit:10};
    await Promise.all([loadRows(clean), loadSummary(clean)]);
  };

  const openAdd = () => {
    setEditingId(null);
    setForm(EMPTY);
    setShowForm(true);
  };

  const openEdit = (r) => {
    setEditingId(r.id);
    setForm({
      jobprofil_id: String(r.jobprofil_id || ""),
      nomor_surat: r.nomor_surat || "",
      level_sanksi: r.level_sanksi || "SP1",
      tanggal_kesalahan: r.tanggal_kesalahan || "",
      kesalahan: r.kesalahan || "",
      masa_aktif_awal: r.masa_aktif_awal || "",
      masa_aktif_akhir: r.masa_aktif_akhir || "",
      status_manual: r.status_manual || "",
      status_sumber: r.status_sumber || "",
      keterangan: r.keterangan || "",
    });
    setShowForm(true);
  };

  const save = async (e) => {
    e.preventDefault();
    if (!form.jobprofil_id) return alert("Karyawan wajib dipilih.");
    if (!form.tanggal_kesalahan) return alert("Tanggal kesalahan wajib diisi.");
    if (!String(form.kesalahan || "").trim()) return alert("Pelanggaran / kesalahan wajib diisi.");

    try {
      setSaving(true);
      if (editingId) await API.put(`${BASE}/${editingId}`, form);
      else await API.post(BASE, form);
      setShowForm(false);
      setEditingId(null);
      setForm(EMPTY);
      await Promise.all([loadRows(), loadSummary()]);
    } catch(e2) {
      alert(errMsg(e2, "Gagal menyimpan Rekap Sanksi."));
    } finally {
      setSaving(false);
    }
  };

  const remove = async (r) => {
    if (!window.confirm(`Hapus data sanksi ${r.nama || r.nik || ""}?`)) return;
    try {
      await API.delete(`${BASE}/${r.id}`);
      await Promise.all([loadRows(), loadSummary()]);
    } catch(e) {
      alert(errMsg(e, "Gagal menghapus Rekap Sanksi."));
    }
  };

  const exportExcel = async () => {
    try {
      const r = await API.get(BASE, { params: { ...filterParams(), page:1, limit:50000 }});
      const all = Array.isArray(r.data?.rows) ? r.data.rows : [];
      if (!all.length) return alert("Tidak ada data untuk diexport.");
      const data = all.map((x,i)=>({
        NO:i+1,
        NIK:x.nik||"",
        NAMA:x.nama||"",
        DEPARTEMEN:x.line_dept||"",
        JABATAN:x.jabatan||"",
        "NOMOR SURAT":x.nomor_surat||"",
        "LEVEL SANKSI":x.level_sanksi||"",
        "TANGGAL KESALAHAN":x.tanggal_kesalahan||"",
        "PELANGGARAN / KESALAHAN":x.kesalahan||"",
        "MASA AKTIF AWAL":x.masa_aktif_awal||"",
        "MASA AKTIF AKHIR":x.masa_aktif_akhir||"",
        STATUS:x.status||"",
        KETERANGAN:x.keterangan||"",
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      ws["!cols"] = [
        {wch:6},{wch:16},{wch:28},{wch:24},{wch:22},{wch:22},{wch:14},
        {wch:18},{wch:55},{wch:18},{wch:18},{wch:16},{wch:40}
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Rekap Sanksi");
      const arr = XLSX.write(wb,{bookType:"xlsx",type:"array"});
      saveAs(new Blob([arr],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}),`rekap_sanksi_${stamp()}.xlsx`);
    } catch(e) {
      alert(errMsg(e, "Gagal export Rekap Sanksi."));
    }
  };

  const pageLabel = useMemo(() => {
    const total = Number(pagination.total || 0);
    if (!total) return "0 data";
    const fromNo = (page-1)*limit + 1;
    const toNo = Math.min(page*limit,total);
    return `${fromNo.toLocaleString("id-ID")} - ${toNo.toLocaleString("id-ID")} dari ${total.toLocaleString("id-ID")}`;
  }, [pagination.total,page,limit]);

  return (
    <div className="rekapsanksi-page">
      <div className="rekapsanksi-head">
        <div>
          <h3>Rekap Sanksi</h3>
          <div className="text-muted">Data pelanggaran karyawan terintegrasi dengan Job Profile.</div>
        </div>
        <div className="rekapsanksi-head-actions">
          <button className="btn btn-success" onClick={exportExcel}><i className="fas fa-file-excel mr-1"/>Export Report</button>
          <button className="btn btn-primary" onClick={openAdd}><i className="fas fa-plus mr-1"/>Tambah Sanksi</button>
        </div>
      </div>

      <div className="rekapsanksi-kpis">
        <div><span>Total</span><strong>{Number(summary.total||0).toLocaleString("id-ID")}</strong></div>
        <div><span>Aktif</span><strong>{Number(summary.aktif||0).toLocaleString("id-ID")}</strong></div>
        <div><span>Expired</span><strong>{Number(summary.expired||0).toLocaleString("id-ID")}</strong></div>
        <div><span>SP1</span><strong>{Number(summary.sp1||0).toLocaleString("id-ID")}</strong></div>
        <div><span>SP2</span><strong>{Number(summary.sp2||0).toLocaleString("id-ID")}</strong></div>
        <div><span>SP3</span><strong>{Number(summary.sp3||0).toLocaleString("id-ID")}</strong></div>
      </div>

      <form className="card border-0 shadow-sm mb-3" onSubmit={applyFilter}>
        <div className="card-body">
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6 mb-2">
              <label>Cari</label>
              <input className="form-control" value={q} onChange={e=>setQ(e.target.value)} placeholder="NIK, nama, no surat, pelanggaran..." />
            </div>
            <div className="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label>Dept</label>
              <select className="form-control" value={dept} onChange={e=>setDept(e.target.value)}>
                <option value="">Semua Dept</option>
                {(meta.departments||[]).map(x=><option key={x} value={x}>{x}</option>)}
              </select>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 mb-2">
              <label>Karyawan</label>
              <select className="form-control" value={jobprofilId} onChange={e=>setJobprofilId(e.target.value)}>
                <option value="">Semua Karyawan</option>
                {(meta.employees||[]).map(x=><option key={x.id} value={x.id}>{x.nik} - {x.nama}</option>)}
              </select>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 mb-2">
              <label>Level</label>
              <select className="form-control" value={level} onChange={e=>setLevel(e.target.value)}>
                <option value="">Semua Level</option>
                {(meta.levels||[]).map(x=><option key={x}>{x}</option>)}
              </select>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 mb-2">
              <label>Status</label>
              <select className="form-control" value={status} onChange={e=>setStatus(e.target.value)}>
                <option value="">Semua Status</option>
                {(meta.statuses||[]).map(x=><option key={x}>{x}</option>)}
              </select>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 mb-2">
              <label>Dari Tanggal</label>
              <input type="date" className="form-control" value={from} onChange={e=>setFrom(e.target.value)} />
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 mb-2">
              <label>Sampai Tanggal</label>
              <input type="date" className="form-control" value={to} onChange={e=>setTo(e.target.value)} />
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 mb-2">
              <label>Rows</label>
              <select className="form-control" value={limit} onChange={e=>{setLimit(Number(e.target.value));setPage(1);}}>
                <option value={10}>10</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={50000}>ALL</option>
              </select>
            </div>
            <div className="col-xl-6 col-lg-9 col-md-12 mb-2 d-flex align-items-end">
              <button className="btn btn-primary mr-2" type="submit"><i className="fas fa-search mr-1"/>Terapkan</button>
              <button className="btn btn-light border" type="button" onClick={resetFilter}>Reset</button>
            </div>
          </div>
        </div>
      </form>

      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white d-flex justify-content-between align-items-center">
          <strong>Data Rekap Sanksi Karyawan</strong>
          <span className="text-muted small">{pageLabel}</span>
        </div>
        <div className="rekapsanksi-table-wrap">
          <table data-sip-hrd-table="rekapsanksi" data-sip-hrd-main="rekapsanksi" data-sip-table-theme="rekap-sanksi" className="table table-hover mb-0 rekapsanksi-table">
            <thead data-sip-hrd-head="rekapsanksi" data-sip-table-theme-head="rekap-sanksi">
              <tr>
                <th>No</th><th>NIK</th><th>Nama</th><th>Dept</th><th>Jabatan</th>
                <th>No Surat</th><th>Level</th><th>Tgl Kesalahan</th><th>Pelanggaran / Kesalahan</th>
                <th>Masa Aktif</th><th>Status</th><th>Keterangan</th><th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="13" className="text-center p-4">Loading...</td></tr>
              ) : rows.length ? rows.map((r,i)=>(
                <tr key={r.id}>
                  <td>{(page-1)*limit+i+1}</td>
                  <td>{r.nik||"-"}</td>
                  <td><b>{r.nama||"-"}</b></td>
                  <td>{r.line_dept||"-"}</td>
                  <td>{r.jabatan||"-"}</td>
                  <td>{r.nomor_surat||"-"}</td>
                  <td><span className={`rs-badge rs-${String(r.level_sanksi||"").toLowerCase()}`}>{r.level_sanksi||"-"}</span></td>
                  <td>{fmtDate(r.tanggal_kesalahan)}</td>
                  <td className="rs-wraptext">{r.kesalahan||"-"}</td>
                  <td>{fmtDate(r.masa_aktif_awal)} s/d {fmtDate(r.masa_aktif_akhir)}</td>
                  <td><span className={`rs-status rs-${String(r.status||"").toLowerCase().replace(/\s+/g,"-")}`}>{r.status||"-"}</span></td>
                  <td className="rs-wraptext">{r.keterangan||"-"}</td>
                  <td className="text-nowrap">
                    <button className="btn btn-sm btn-primary mr-1" onClick={()=>openEdit(r)}>Edit</button>
                    <button className="btn btn-sm btn-danger" onClick={()=>remove(r)}>Hapus</button>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan="13" className="text-center text-muted p-4">Belum ada data Rekap Sanksi.</td></tr>
              )}
            </tbody>
          </table>
        </div>
        {limit < 50000 && (
          <div className="card-footer bg-white d-flex justify-content-between align-items-center">
            <button className="btn btn-light border" disabled={page<=1} onClick={()=>setPage(p=>Math.max(1,p-1))}>Prev</button>
            <b>Page {page} / {pagination.totalPages||1}</b>
            <button className="btn btn-light border" disabled={page>=(pagination.totalPages||1)} onClick={()=>setPage(p=>p+1)}>Next</button>
          </div>
        )}
      </div>

      {showForm && (
        <div className="rs-modal-backdrop" onClick={()=>!saving&&setShowForm(false)}>
          <div className="rs-modal" onClick={e=>e.stopPropagation()}>
            <div className="rs-modal-head">
              <div><b>{editingId ? "Edit Rekap Sanksi" : "Tambah Rekap Sanksi"}</b><small> Terhubung ke data Job Profile berdasarkan karyawan yang dipilih.</small></div>
              <button className="btn btn-sm btn-light border" onClick={()=>setShowForm(false)} disabled={saving}>Tutup</button>
            </div>
            <form onSubmit={save}>
              <div className="rs-form-grid">
                <div className="rs-full">
                  <label>Karyawan *</label>
                  <SearchableSelect className="form-control" value={form.jobprofil_id} onChange={e=>setForm({...form,jobprofil_id:e.target.value})} required>
                    <option value="">Pilih Karyawan</option>
                    {(meta.employees||[]).map(x=><option key={x.id} value={x.id}>{x.nik} - {x.nama} | {x.line_dept||"-"} | {x.jabatan||"-"}</option>)}
                  </SearchableSelect>
                </div>
                <div><label>Nomor Surat</label><input className="form-control" value={form.nomor_surat} onChange={e=>setForm({...form,nomor_surat:e.target.value})}/></div>
                <div>
                  <label>Level Sanksi</label>
                  <select className="form-control" value={form.level_sanksi} onChange={e=>setForm({...form,level_sanksi:e.target.value})}>
                    {(meta.levels||["SP1","SP2","SP3","TEGURAN","LAINNYA"]).map(x=><option key={x}>{x}</option>)}
                  </select>
                </div>
                <div><label>Tanggal Kesalahan *</label><input type="date" className="form-control" value={form.tanggal_kesalahan} onChange={e=>setForm({...form,tanggal_kesalahan:e.target.value})} required/></div>
                <div><label>Masa Aktif Awal</label><input type="date" className="form-control" value={form.masa_aktif_awal} onChange={e=>setForm({...form,masa_aktif_awal:e.target.value})}/></div>
                <div><label>Masa Aktif Akhir</label><input type="date" className="form-control" value={form.masa_aktif_akhir} onChange={e=>setForm({...form,masa_aktif_akhir:e.target.value})}/></div>
                <div>
                  <label>Status Manual</label>
                  <select className="form-control" value={form.status_manual} onChange={e=>setForm({...form,status_manual:e.target.value})}>
                    <option value="">Otomatis sesuai masa aktif</option>
                    <option value="DIBATALKAN">DIBATALKAN</option>
                  </select>
                </div>
                <div className="rs-full"><label>Pelanggaran / Kesalahan *</label><textarea className="form-control" rows="3" value={form.kesalahan} onChange={e=>setForm({...form,kesalahan:e.target.value})} required/></div>
                <div className="rs-full"><label>Keterangan</label><textarea className="form-control" rows="3" value={form.keterangan} onChange={e=>setForm({...form,keterangan:e.target.value})}/></div>
              </div>
              <div className="rs-modal-foot">
                <button type="button" className="btn btn-light border mr-2" onClick={()=>setShowForm(false)} disabled={saving}>Batal</button>
                <button className="btn btn-primary" disabled={saving}>{saving ? "Menyimpan..." : (editingId ? "Update" : "Simpan")}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
